// Configuration for multiple shadow DOM targets
const shadowTargets = [
    {
        hostSelector: '#app-embed-container-369073', 
        styles: `
            /* Your styles for first shadow DOM */
            button {
                border-radius: 0 !important;
            }
            input {
                border-radius: 0 !important;
                border: 1px solid #232323 !important;
                font: var(--forms-body-font) !important;
            }
            label {
                font-family: var(--forms-body-font) !important;
                color: #232323 !important;
                text-transform: uppercase;
                font-size: 11px !important;
                top: 50% !important;
                transform: translate(0, -50%) !important;
            }
            input:focus + label {
                top: 10px !important;
                transform: translate(0, 0) !important;
                scale: 80%;
            }
            [class*="_formContainerCloseButtonPosition"] {
                top: 16px !important;
                right: 16px !important;
            }
        `
    }
];

// Function to inject styles into shadow DOM
function injectShadowStyles(shadowHost, styles) {
    if (shadowHost.shadowRoot) {
        // Check if we already injected styles (to avoid duplicates)
        if (!shadowHost.shadowRoot.querySelector('[data-custom-styles]')) {
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-custom-styles', 'true');
            styleElement.textContent = styles;
            shadowHost.shadowRoot.appendChild(styleElement);
        }
    }
}

// Set up observer for each target
shadowTargets.forEach(target => {
    // Try to inject immediately if element already exists
    const existingElements = document.querySelectorAll(target.hostSelector);
    existingElements.forEach(el => injectShadowStyles(el, target.styles));
    
    // Set up observer for dynamically added elements
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    // Check if this node matches our selector
                    if (node.matches && node.matches(target.hostSelector)) {
                        injectShadowStyles(node, target.styles);
                    }
                    // Also check descendants
                    if (node.querySelectorAll) {
                        const descendants = node.querySelectorAll(target.hostSelector);
                        descendants.forEach(el => injectShadowStyles(el, target.styles));
                    }
                }
            });
        });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
});